import { Box } from '@mui/material';

import { Project } from '@arra/core';
import { useTranslation } from 'react-i18next';
import { User } from '../../../authentication/context/useUser';
import Markdown from '../../../ui/Markdown';
import mic from '../images/Service Radiophonique principal.svg';
import { ContentLayout, PageLayout, Text } from '../layout';
import { Footer } from './Footer';
import { Header } from './Header';

export const APropos = ({
  project,
  user,
}: {
  project: Project;
  user: User;
}) => {
  const { t } = useTranslation(['project']);

  if (!project) {
    return null;
  }

  return (
    <PageLayout>
      <Header project={project} pageNumber={4} />
      <ContentLayout>
        <Box height="30px" />
        <Box display="flex" columnGap={3} alignItems={'center'}>
          <img src={mic} width="80px" alt="mic" />
          <Text fontSize="70px" fontWeight="bold">
            A propos
          </Text>
        </Box>
        <Box height="30px" />

        <Box
          height="1px"
          width="100%"
          marginBottom={5}
          sx={{
            background:
              'repeating-linear-gradient(90deg,var(--PURPLE) 0 20px,white 0 40px)',
          }}
        />

        <Box
          display="flex"
          columnGap={3}
          width="100%"
          alignItems="center"
          justifyContent="space-between"
          paddingX="5%"
        >
          <Text fontSize="28px" fontWeight="bold" textAlign="left">
            SONAR
          </Text>
          {/* <Box>
            <img src={lights} width="80px" alt="" />
          </Box> */}
        </Box>
        <Box height="30px" />
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          justifyContent="center"
          paddingX="5%"
        >
          <Markdown>{t('project:pdfExport.about')}</Markdown>
        </Box>
      </ContentLayout>
      <Footer project={project} user={user} />
    </PageLayout>
  );
};
